export default {
      id: "api-token-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "sprite-46b249.svg#api-token-usage",
      toString: function () {
        return this.url;
      }
    }